export enum BluetoothLowEnergyEnum {
    none = 0,
    iBeacon = 1,
}
